<template>
  <div class="msg" v-loading.fullscreen.lock="pageLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div style="text-align: left; margin-bottom: 15px;">
      <!-- <el-radio v-model="recordType" label="1" border>廣播記錄</el-radio>
      <el-radio v-model="recordType" label="2" border>點數使用記錄</el-radio> -->
      <el-radio-group v-model="searchDuration" fill="#777" @change="getRecords">
        <el-radio-button label="day">1 天</el-radio-button>
        <el-radio-button label="week">7 天</el-radio-button>
        <el-radio-button label="month">30 天</el-radio-button>
      </el-radio-group>
    </div>
    <!-- 點數使用記錄 -->
    <div style="text-align: left;" v-if="recordType === '2'">
      <el-select v-model="selectedYear" size="small" style="width: 120px;">
        <el-option v-for="item in years"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-table v-if="pointRecord[selectedYear]" :data="pointRecord[selectedYear].filter(el => el.month !== '0')" empty-text="目前無記錄" key="pointTable" border height="calc(100vh - 350px)" style="margin-top: 10px;">
        <el-table-column prop="month"
          label="月份"
          sortable>
        </el-table-column>
        <el-table-column prop="count"
          label="使用點數">
        </el-table-column>
      </el-table>
    </div>
    <!-- 廣播記錄 -->
    <div class="broadcastTable" v-if="recordType === '1'">
      <el-table ref="removeID" :data="broadcastRecords" :empty-text="emptyText" key="table1" height="calc(100vh - 350px)" @selection-change="handleSelectionChange">
        <!-- <el-table-column
          type="selection"
          width="55">
        </el-table-column> -->
        <!-- 廣播時間 -->
        <el-table-column prop="type"
          :width="230"
          label="廣播時間"
          sortable>
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px;">{{ scope.row ? getTime(scope.row.time) : '無資料' }}</span>
          </template>
        </el-table-column>
        <!-- 廣播卡片 -->
        <el-table-column prop="type"
          label="廣播卡片">
          <template slot-scope="scope">
            <span style="font-weight: 400; font-size: 15px;">{{ (scope.row && scope.row.cardName) ? scope.row.cardName.replace('@$@', '').replace('@#@', '') : '-' }}</span>
          </template>
        </el-table-column>
        <!-- 廣播標籤 -->
        <el-table-column prop="type"
          label="廣播標籤">
          <template slot-scope="scope">
            <span style="font-weight: 400; font-size: 15px;">{{ (scope.row && scope.row.tag) ? scope.row.tag : '無' }}</span>
          </template>
        </el-table-column>
        <!-- 廣播標籤 -->
        <el-table-column prop="type"
          :width="150"
          label="發送人數">
          <template slot-scope="scope">
            <span style="font-weight: 400; font-size: 15px;">{{ (scope.row && scope.row.totalRecipient) ? scope.row.totalRecipient : 0 }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div style="margin-top: 10px; text-align: right;">
        <el-button type="danger" :disabled="removeID.length < 1" @click="removeBroadcast">刪除紀錄</el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions } from 'vuex';

export default {
  name: 'broadcastRecord',
  data() {
    return {
      service: this.$route.params.service,
      auth: this.$route.params.id,
      recordType: '1',
      searchDuration: 'day',
      selectedYear: '2020',
      pageLoading: false,
      removeID: [],
      broadcastRecords: [],
      emptyText: '載入中...',
      years: ['2020', '2021'],
    }
  },
  props: ['pointRecord'],
  mounted() {
    this.getAllBroadcast('day', null, null);
  },
  methods: {
    ...mapActions({
      getbroadcastRecord: 'broadcastRecord',
      removeBroadcasts: 'removeBroadcasts',
      broadcastRecordByTime: 'broadcastRecordByTime'
    }),
    showFlassMessage(message, time) {
      this.$notify({
        title: message,
        type: 'success'
      });
    },
    getRecords(val) {
      this.getAllBroadcast(val, null, null);
    },
    getAllBroadcast(duration, start, end) {
      this.broadcastRecords = [];
      this.emptyText = '載入中...';
      const postData = {
        service: this.service, auth: this.auth, duration, start, end
      };
      this.broadcastRecordByTime(postData).then((res) => {
        this.emptyText = '目前無廣播記錄';
        this.broadcastRecords = (res.data.length > 0) ? res.data.sort((a, b) => b.time - a.time) : [];
      })
    },
    getTime(time) {
      return new Date(time).toLocaleString();
    },
    handleSelectionChange(val) {
      this.removeID = val;
    },
    removeBroadcast() {
      this.pageLoading = true;
      const removeId = this.removeID.map(el => el[0]);
      this.removeBroadcasts({ service: this.service, auth: this.auth, removeId: removeId })
        .then(() => {
          this.pageLoading = false;
          this.getAllBroadcast();
          this.showFlassMessage('已刪除廣播記錄', 2000);
        })
    }
  },
}
</script>

<style scoped>
.textarea {
  text-align: left;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  border-radius: 7px;
}
.selector {
  border: 1px solid #cfcfcf;
  margin-right: -1px;
  padding: 15px 11px;
  line-height: 47px;
}
.blue_btn {
  background: rgba(48, 117, 229, 0.2);
  border: 1px solid rgba(48, 117, 229, 1);
  color: rgba(48, 117, 229, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.blue_btn:hover {
  background: rgba(255, 28, 28, 0.2);
  border: 1px solid rgba(255, 28, 28, 1);
  color: rgba(255, 28, 28, 1);
  transform: translateY(-3px);
  display: inline-block;
  padding: 2px 15px;
  font-size: 16px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}
.msg {
  margin: 0 auto;
  background-color: #fff;
  padding: 15px;
  border-radius: 5px;
  width: 89%;
  /* min-width: 750px; */
  max-width: 850px;
  box-shadow: 2px 2px 12px -1px rgba(20% ,20% ,40% ,0.5);
}
.work {
  font-size: 17px;
}
.layout {
  min-width: 100%;
  max-width: 100%;
  margin-left: 0!important;
  flex: 1 1 100%;
  padding: 30px;
}
.card {
  border-radius: 3px;
  background-color: #999;
  padding: 15px;
  margin-top: -20px;
  margin-right: 15px;
  float: left;
}
</style>